<div class="rightComp action-plan-page">
  <div class="col-12 action-item-container">
    <!-- Header -->
    <div *ngIf="enforcementDetail && enforcementDetail.length===0" class="action-item-section-header mb-3"
      [ngClass]="isArabic ? 'flex-row-reverse': 'flex-row'">

      <span *ngIf="!isArabic"> No active enforcement found</span>
      <span *ngIf="isArabic">لم يتم العثور على سجل للإجراءات التنفيذية</span>
    </div>
    <div *ngIf="enforcementDetail && enforcementDetail.length>0" class="action-item-section-header mb-3"
      [ngClass]="isArabic ? 'flex-row-reverse': 'flex-row'">
      <div>
        <div *ngIf="!isArabic">
          <span class="header-font">Assessment Name: </span>
          <span class="font-radikal-light">{{ enforcementDetail[0]?.mde_AssessmentEntity?.name }}</span>
        </div>
        <div *ngIf="isArabic" style="text-align: right; display: flex; justify-content: flex-start; gap: 5px;">
          <span class="font-radikal-light">{{ enforcementDetail[0]?.mde_AssessmentEntity?.name }}</span>
          <span class="header-font">:اسم التقييم</span>
        </div>

        <div *ngIf="!isArabic">
          <span class="header-font">Inspection: </span>
          <span class="font-radikal-light">{{ enforcementDetail[0]?.mde_InspectionPlan?.mde_name }}</span>
        </div>
        <div *ngIf="isArabic" style="text-align: right; display: flex; justify-content: flex-start; gap: 5px;">
          <span class="font-radikal-light">{{ enforcementDetail[0]?.mde_InspectionPlan?.mde_actionplannamearabic }}</span>
          <span class="header-font">:التفتيش</span>
        </div>
      </div>
    </div>

    <!-- Table -->
    <table class="table table-striped customTable" *ngFor="let enforcement of enforcementDetail; let i = index">
      <tbody>
        <tr>
          <td>
            <!-- Action Item Header -->
            <section class="action-item-header enforcement-summary" [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">
              <div class="action-item-main">
                <div class="action-item-header" [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">
                  <div class="index-circle">
                    <span><b>{{ i + 1 }}</b></span>
                  </div>
                  <div class="action-item-title" [ngClass]="isArabic ? 'action-item-title-ar rtl' :''">
                    <span *ngIf="!isArabic">{{enforcement.mde_actionitem?.mde_name}}</span>
                    <span *ngIf="isArabic">{{enforcement.mde_actionitem?.mde_actionitemarabicname}}</span>
                  </div>
                </div>

                <!-- Violation -->
                <div class="action-item-violation" [ngClass]="isArabic ? 'pull-right' : 'pull-left'">
                  <ng-container *ngIf="!isArabic">
                    Violation:
                    <span class="font-radikal-light">{{ enforcement.mde_Violation?.mde_name }}</span>
                  </ng-container>
                  <ng-container *ngIf="isArabic">
                    <b>المخالفة:</b> {{ enforcement.mde_Violation?.mde_arabicviolation }}
                  </ng-container>
                </div>

                <!-- Comment History -->
                <div class="mt-3">
                  <details [ngClass]="isArabic ? 'pull-right rtl' : 'pull-left'">
                    <summary>
                      <ng-container *ngIf="!isArabic">Comment History</ng-container>
                      <ng-container *ngIf="isArabic">سجل التعليقات</ng-container>
                    </summary>
                    <ng-container>
                      <pre class="mt-0 mb-0 overflow-hidden">
{{ enforcement.mde_comment || 'No comments' }}
                      </pre>
                    </ng-container>
                  </details>
                </div>
                <div class="mt-2">
                  <details [ngClass]="isArabic ? 'pull-right rtl' : 'pull-left'">
                    <summary (click)="toggleDocuments(enforcement)">
                      <ng-container *ngIf="!isArabic">Attached Documents</ng-container>
                      <ng-container *ngIf="isArabic">
                        المستندات المرفقة</ng-container>
                    </summary>
                    <ng-container>
                      <div *ngIf="enforcement.showDocuments" class="document-list mt-2 ms-4">
                        <ng-container *ngIf="enforcement?.fetchedDocuments?.length===0">
                          <p class="text-muted fst-italic">No documents attached.</p>
                        </ng-container>
                        <ul class="list-unstyled">
                          <li *ngFor="let document of enforcement.fetchedDocuments; let docIndex = index"><span
                              class="me-2">{{ docIndex + 1 }}.</span>{{ document.filename }}</li>
                        </ul>
                      </div>
                    </ng-container>
                  </details>
                </div>
                <!-- buttons to toggle collapses -->
                <div *ngIf="!isHistorical" class="plan-buttons-container mt-3"
                  [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">
                  <button type="button" class="plan-button" data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#commentsbox_'+i" aria-expanded="false">
                    <ng-container *ngIf="!isArabic">Comment</ng-container>
                    <ng-container *ngIf="isArabic">التعليقات</ng-container>
                  </button>

                  <button type="button" class="plan-button" data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#attachmentsection_'+i" aria-expanded="false">
                    <ng-container *ngIf="!isArabic">Upload</ng-container>
                    <ng-container *ngIf="isArabic">تحميل</ng-container>
                  </button>
                </div>
                <!-- Interaction area (comment/upload/submit) -->
                <section class="action-item-interaction mt-1" [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">

                  <!-- comment textarea (collapsed) -->
                  <textarea class="form-control comment w-70 collapse"
                    [placeholder]="!isArabic ? 'Enter here' : 'أدخل هنا'" [attr.id]="'commentsbox_'+i"
                    (input)="onEnforcementCommentChange($event, i)" (keyup)="onEnforcementKeyup($event, i)"
                    [disabled]="isHistorical || enforcement?.isSubmitted">{{ enforcement?.comments || '' }}</textarea>

                  <div [attr.id]="'attachmentsection_'+i" class="collapse mw-50p">

                    <!-- Main file input (multiple selection enabled) -->
                    <ng-container>
                      <input type="file" multiple (change)="onEnforcementFileSelected($event, i)"
                        [disabled]="isHistorical || enforcement?.isSubmitted" />
                    </ng-container>
                    <ng-container>
                      <ul *ngIf="enforcement.attachedFiles?.length > 0" class="list-unstyled">
                        <li *ngFor="let file of enforcement.attachedFiles; let fi = index" class="me-2">
                          {{fi+1}}.{{ file.name }}
                          <!-- Delete icon for new files only -->
                          <label *ngIf="!isHistorical && !enforcement?.isSubmitted">
                            <img src="../../../assets/images/delete.png" alt="Delete" class="del-icon"
                              style="cursor: pointer; margin-left: 10px;" (click)="onDeleteNewFile(i, fi)" />
                          </label>
                        </li>
                      </ul>
                    </ng-container>

                  </div>
                </section>
                <span *ngIf="enforcement?.showError" class="errMsg">
                  <ng-container *ngIf="!isArabic">Please provide comments before submitting the
                    enforcement</ng-container>
                  <ng-container *ngIf="isArabic">يرجى تقديم التعليقات قبل إرسال عنصر التنفيذ</ng-container>
                </span>
                <section *ngIf="!isHistorical" class="action-item-submit-container"
                  [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">
                  <div class="action-item-submit-section">
                    <button type="button" class="btn-sm btn-primary ratButton rightBtn nextButton action-item-submit"
                      [disabled]="enforcement?.disableSubmit || enforcement?.isSubmitted"
                      (click)="submitEnforcementCheck(enforcement, i)">
                      <ng-container *ngIf="!enforcement.isSubmitted">
                        <ng-container *ngIf="!isArabic">Submit</ng-container>
                        <ng-container *ngIf="isArabic">إرسال</ng-container>
                      </ng-container>
                      <ng-container *ngIf="enforcement.isSubmitted">
                        <ng-container *ngIf="!isArabic">Submitted</ng-container>
                        <ng-container *ngIf="isArabic">تم الإرسال</ng-container>
                      </ng-container>
                    </button>


                  </div>
                </section>

              </div>

              <!-- Right Info Panel -->
              <div class="right-list" [ngClass]="isArabic ? 'mr-auto' : 'ml-auto'">
                <!-- Status -->
                <div class="redbtn-div"
                  [ngClass]="isArabic ? 'pull-left collapse-first-left-padding rtl' : 'pull-right collapse-last-right-padding'">
                  <span class="p-1">
                    <div [ngClass]="isArabic ? 'rtl' : 'ltr'">
                      <span *ngIf="!isArabic">Status: </span>
                      <span *ngIf="isArabic"> الحالة : </span>
                      <span class="font-radikal-light redbtn">{{ enforcement.mde_name }}</span>
                    </div>
                  </span>
                </div>



                 <div [ngClass]="isArabic ? 'pull-left rtl' : 'pull-right'">
                  <ng-container *ngIf="!isArabic">Action Category: </ng-container>
                  <ng-container *ngIf="isArabic"> فئة الإجراء : </ng-container>
                  <span class="font-radikal-light">{{ enforcement.mde_actioncategory || '-'  }}</span>
                </div>
                 <div [ngClass]="isArabic ? 'pull-left rtl' : 'pull-right'">
                  <ng-container *ngIf="!isArabic">Criticality : </ng-container>
                  <ng-container *ngIf="isArabic"> تاريخ الإنشاء :</ng-container>
                  <span class="font-radikal-light">{{ enforcement.mde_criticality || '-' }}</span>
                </div>
                <!-- Creation Date -->
                <div class="action-item-date" [ngClass]="isArabic ? 'pull-left' : 'pull-right'">
                  <ng-container *ngIf="!isArabic">Creation: </ng-container>
                  <ng-container *ngIf="isArabic">تاريخ الإنشاء : </ng-container>
                  <span class="font-radikal-light">{{ enforcement.createdon | date:'dd/MM/yyyy' }}</span>
                </div>

                <!-- Target Date -->
                <div [ngClass]="isArabic ? 'pull-left' : 'pull-right'">
                  <ng-container *ngIf="!isArabic">Target: </ng-container>
                  <ng-container *ngIf="isArabic">التاريخ المستهدف : </ng-container>
                  <span class="font-radikal-light">{{ enforcement.mde_targetdate | date:'dd/MM/yyyy' }}</span>
                </div>

                <!-- Fine Amount -->
                <div class="action-item-date" [ngClass]="isArabic ? 'pull-left rtl' : 'pull-right'">
                  <ng-container *ngIf="!isArabic">Initial Fine Amount: </ng-container>
                  <ng-container *ngIf="isArabic"> المبلغ : </ng-container>
                  <span class="font-radikal-light redtext">
                    AED {{
                    enforcement.mde_name === 'Warning1' ? enforcement.mde_Violation?.mde_1stwarningfines :
                    enforcement.mde_name === 'Warning2' ?
                    enforcement.mde_Violation?.mde_2ndwarningremediationtimeframefines :
                    enforcement.mde_name === 'Warning3' ?
                    enforcement.mde_Violation?.mde_3rdwarningandsuspensionperiodfines :
                    '0.00'
                    || '0.00' }}
                  </span>
                </div>
                <div class="action-item-date" [ngClass]="isArabic ? 'pull-left rtl' : 'pull-right'">
                  <ng-container *ngIf="!isArabic">Total Fine Amount: </ng-container>
                  <ng-container *ngIf="isArabic">المبلغ:</ng-container>
                  <span class="font-radikal-light redtext">
                    AED {{ enforcement.mde_totalfineammount || '0.00' }}
                  </span>
                </div>
              </div>
              <div class="upload-overlay"></div>
              <div id="uploadPopup" class="upload-popup">
                <p *ngIf="!isArabic">Uploading files, please wait...</p>
                <p *ngIf="isArabic">يتم الآن تحميل الملفات، يُرجى الانتظار.</p>
                <progress id="uploadProgressBar" value="0" max="100" style="width: 100%; height: 20px;"></progress>
                <p id="progressPercent" style="text-align: right; margin: 5px 0 0;">0%</p>
              </div>
            </section>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>